import Image28 from './../../img/image 28.png';
import Image27 from './../../img/image 27.png';
import Image34 from './../../img/image 34.png';
import Image35 from './../../img/image 35.png';
import Image36 from './../../img/image 36.png';
import Image37 from './../../img/image 37.png';

export const MainMenuData = [
    {
        image: `${Image28}`,
        heading:'Steak',
        review:'Grilled premium quality beef and unforgettable flavor of special sauce',
        price:'GEL 28',
    },
    {
        image: `${Image27}`,
        heading:'Steak',
        review:'Grilled premium quality beef and unforgettable flavor of special sauce',
        price:'GEL 27',
    },
    {
        image: `${Image34}`,
        heading:'Steak',
        review:'Grilled premium quality beef and unforgettable flavor of special sauce',
        price:'GEL 34',
    },
    {
        image: `${Image35}`,
        heading:'Steak',
        review:'Grilled premium quality beef and unforgettable flavor of special sauce',
        price:'GEL 35',
    },
    {
        image: `${Image36}`,
        heading:'Steak',
        review:'Grilled premium quality beef and unforgettable flavor of special sauce',
        price:'GEL 36',
    },
    {
        image: `${Image37}`,
        heading:'Steak',
        review:'Grilled premium quality beef and unforgettable flavor of special sauce',
        price:'GEL 37',
    }
]